import gsap from 'gsap/all'

import Animation from '../classes/Animation'

export default class extends Animation {
  constructor (element) {
    super({
      element
    })
  }

  animateIn () {
    super.animateIn()

    gsap.to(this.element, {
      opacity: 1,
      y: 0,
      duration: 0.4,
      delay: 0.1,
      ease: 'power2.out'
    })
  }

  animateOut () {
    super.animateOut()

    gsap.set(this.element, {
      opacity: 0,
      y: '2rem'
    })
  }
}
